export const validateInput = (name, value, formValues) => {
    let error = '';

    switch (name) {
        case 'reference':
            if (!value.trim()) {
                error = 'La referencia es obligatoria';
            } else if (value.trim().length < 2) {
                error = 'La referencia debe tener al menos 2 caracteres';
            }
            break;

        case 'contact':
            if (!value.trim()) {
                error = 'El contacto es obligatorio';
            } else if (!/^[a-zA-Z\s]+$/.test(value)) {
                error = 'El contacto solo debe contener letras y espacios';
            }
            break;

        case 'prospect':
            if (!value.trim()) {
                error = 'El prospecto es obligatorio';
            }
            break;

        case 'loyal':
            if (!value.trim()) {
                error = 'El campo "Leal" es obligatorio';
            }
            break;

        case 'client':
            if (!value.trim()) {
                error = 'El campo "Cliente" es obligatorio';
            } else if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/.test(value)) {
                error =
                    'El campo "Cliente" solo debe contener letras y espacios';
            }
            break;

        case 'clientType':
            if (!value) {
                error = 'El tipo de cliente es obligatorio';
            }
            break;

        case 'clientName':
            if (!value.trim()) {
                error = 'El nombre del cliente es obligatorio';
            } else if (value.trim().length < 2) {
                error = 'El nombre debe tener al menos 2 caracteres';
            } else if (
                !/^([A-ZÁÉÍÓÚÑ][a-záéíóúñ]+)(\s[A-ZÁÉÍÓÚÑ][a-záéíóúñ]+)*$/.test(
                    value
                )
            ) {
                error =
                    'Cada nombre debe comenzar con mayúscula y solo contener letras, espacios y caracteres especiales permitidos';
            }
            break;

        case 'email':
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                error = 'Formato de correo electrónico inválido';
            }
            break;

        case 'phone':
            const phoneRegex =
                /^\+?\d{1,3}[-.\s]?\(?\d{1,4}\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;

            if (!phoneRegex.test(value)) {
                error =
                    'El teléfono debe tener un formato válido. Ejemplo: +52 (55) 1234 5678.';
            }
            break;

        case 'saleValue':
            const numericValue = parseFloat(value.replace(/[^\d.-]/g, ''));

            if (isNaN(numericValue) || numericValue <= 0) {
                error = 'El valor de venta debe ser un número positivo';
            }
            break;

        case 'observations':
            const badWords = ['mala1', 'mala2', 'mala3'];
            const containsBadWords = badWords.some(badWord =>
                value.toLowerCase().includes(badWord)
            );

            if (!value.trim()) {
                error = 'Las observaciones son obligatorias';
            } else if (value.trim().length < 10) {
                error = 'Las observaciones deben tener al menos 10 caracteres';
            } else if (value.trim().length > 150) {
                error = 'Las observaciones no deben exceder los 150 caracteres';
            } else if (containsBadWords) {
                error = 'Las observaciones contienen palabras inapropiadas';
            } else if (!/^[A-Za-zÁÉÍÓÚáéíóúÑñ\s.,]+$/.test(value)) {
                error =
                    'Las observaciones solo deben contener letras, espacios, comas, puntos y caracteres especiales permitidos';
            }
            break;

        case 'date1':
        case 'date2':
        case 'date3':
        case 'date4':
        case 'date5':
            if (!value) {
                error = 'La fecha es obligatoria';
            }
            break;

        default:
            break;
    }

    return error;
};
